import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { getInitialTextValue } from '../../FormDefinitionInput.utils';
import styles from './HyperLink.styles';

const propTypes = {
  formDefinition: PropTypes.object.isRequired,
};

const HyperLink = ({ formDefinition }) => {
  return (
    <h3
      key={`${formDefinition.orderFormHeaderId}-${formDefinition.formDefinitionId}`}
      className={classNames('row-start-center')}
      style={{ marginTop: 5, marginBottom: 5 }}
    >
      <a className={classNames('account-dropdown-link')} target="_blank" href={getInitialTextValue(formDefinition)}>
        Link
      </a>
    </h3>
  );
};

HyperLink.propTypes = propTypes;
export default withStyles(styles)(HyperLink);
